import { ObjectConfigurationContext } from './types';

export const hasMoreRetries = (context: ObjectConfigurationContext) =>
  context.retries! < context.maxRetries!;

export const canSaveCustomObject = (context: ObjectConfigurationContext) =>
  context.selectedObject &&
  (context.selectedEmailAttribute || context.selectedDomainAttribute);

export const canSelectAttribute = (context: ObjectConfigurationContext) =>
  context.selectedObject && context.targetAttributes?.length;
